<template>
  <div class="ts-expansion-panel">
    <div class="title">
      <div class="title-content" @click="handleToggleClick">
        <slot name="title"></slot>
      </div>
      <div class="toggle" :class="{ reverse: open }" @click="handleToggleClick">
        <ChevronDownLarge />
      </div>
    </div>
    <CollapseTransition>
      <div v-if="open" class="content">
        <slot></slot>
      </div>
    </CollapseTransition>
  </div>
</template>

<style lang="scss" scoped>
.ts-expansion-panel {
  border-radius: 24px;
  box-shadow: 6px 6px 16px 0 rgba(166, 171, 189, 0.4), -6px -6px 16px 0 rgba(250, 251, 255, 0.4);
  border: solid 2px rgba(255, 255, 255, 0.32);
  background-blend-mode: soft-light, normal;
  background-image: linear-gradient(324deg, #000000 100%, var(--fills-neutral-white) -6%),
    linear-gradient(to bottom, #ebecf0, #ebecf0);
  padding: 16px;

  .title {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .toggle {
      cursor: pointer;
      transition: transform 0.3s;
      transform: rotate(270deg);

      &.reverse {
        transform: rotate(180deg);
      }
    }
  }

  .title-content {
    flex-grow: 1;
    cursor: pointer;
  }
}
</style>

<script>
import { CollapseTransition } from 'vue2-transitions';

import ChevronDownLarge from '../../assets/chevron-down-large.svg';

export default {
  name: 'TsExpansionPanel',
  components: {
    CollapseTransition,
    ChevronDownLarge
  },
  data() {
    return {
      open: false
    };
  },
  methods: {
    handleToggleClick() {
      this.open = !this.open;
      this.$emit('input', this.open);
    }
  }
};
</script>
